import { Typography, Grid, Badge } from "@mui/material";
import { React, useEffect, useState } from "react";
import Jobcard from "../../components/JobPageCard";
import HeaderFooterHoc from "../../HOC/HeaderFooterHOC";
import "react-slideshow-image/dist/styles.css";
import Carousel from "react-material-ui-carousel";
import { Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  useFetchProductDetailsQuery,
  useFetchCardDetailsQuery,
} from "../../reducer/productReducer";
import img1 from "../../assets/splash1.jpg";
import img2 from "../../assets/splash2.jpg";
import img3 from "../../assets/splash3.jpg";
import "./styles.css";

function JobPage() {
  const navigate = useNavigate();
  const { data: productList } = useFetchProductDetailsQuery();
  const { data: existingJobList } = useFetchCardDetailsQuery();
  
  const [loginVal, setLoginVal] = useState("");
  const [jobCounts, setJobCounts] = useState({});

  useEffect(() => {
    const token = localStorage.getItem("token"); // Retrieve token

    const fetchJobStatusCounts = async () => {
      try {
        const response = await fetch("https://jobmanagement-497524552274.us-central1.run.app/api/jobs/status-count", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Job Counts API Response:", data); // Debugging log
        setJobCounts(data); // Store the job counts
      } catch (error) {
        console.error("Error fetching job status counts:", error);
      }
    };

    fetchJobStatusCounts();
  }, []);

  useEffect(() => {
    let value = localStorage.getItem("login");
    setLoginVal(value);
  }, []);

  const jobStatusSections = [
    { label: "CREATE A JOB", badgeColor: "primary", path: "/newJob" },
    { label: "NEW JOBS", key: "CREATED", badgeColor: "secondary", path: "/CreatedJobs" },
    { label: "COMPLETED JOBS", key: "COMPLETED", badgeColor: "success", path: "/CompletedJobs" },
    { label: "CANCELLED & RESCHEDULED JOBS", key: "CANCELLED", badgeColor: "error", path: "/CancelledAndRescheduledJobs" },
    { label: "QUOTES FOR ALL JOBS", key: "QUOTES", badgeColor: "info", path: "/TopQuotes" },
    { label: "PAUSED JOBS", key: "PAUSED", badgeColor: "warning", path: "/PausedJobs" },
    { label: "PAID JOBS", key: "PAID", badgeColor: "success", path: "/PaidJobs" },
    { label: "JOBS IN PROGRESS", key: "IN_PROGRESS", badgeColor: "error", path: "/InProgressJob" },
  ];


  const renderJobStatusGrid = () => (
    <Grid container spacing={2} p={2} justifyContent="center">
      {jobStatusSections.map((section, index) => (
        <Grid item xs={6} key={index}>
          <div className="Job" onClick={() => navigate(section.path)}>
            <Typography sx={{ fontSize: "14px", textAlign: "center", mb: 1 }}>
              {section.label}
            </Typography>
            <div className="joblist" id={`box-${section.badgeColor}`} style={{ height: "80px", width: "550px" }}>
              <Badge badgeContent={jobCounts[section.key] || 0} color={section.badgeColor}>
                <Typography sx={{ fontSize: "20px", fontWeight: 700 }}>
                  {jobCounts[section.key] || 0}
                </Typography>
              </Badge>
            </div>
          </div>
        </Grid>
      ))}
    </Grid>
  );

  return (
    <Grid height="100%" width="100%" backgroundColor="#FFFFFF">
      {loginVal ? (
        <>
          <Typography p={2} align="left" sx={{ backgroundColor: "#f2f2f2", fontSize: "18px", fontWeight: 900 }}>
            All your Jobs
          </Typography>
          {renderJobStatusGrid()}
        </>
      ) : (
        <div style={{ height: "200px", paddingBottom: "50px" }} className="slide-container">
          <Carousel sx={{ paddingBottom: "20px" }}>
            {[img1, img2, img3].map((img, i) => (
              <Paper key={i} elevation={0} className="item">
                <img style={{ height: "220px", width: "100%" }} alt="" src={img} />
              </Paper>
            ))}
          </Carousel>
        </div>
      )}
      <Grid bgcolor="#F7F7F7" container pt={3} paddingLeft="5%" px={2}>
        <Typography className="JobCategoryHeading"></Typography>
      </Grid>
      <Jobcard productList={productList} existingJobList={existingJobList} />
    </Grid>
  );
}

export default HeaderFooterHoc(JobPage, { bodyClassname: "" });
